import { connect } from 'react-redux'
import { chatbotSelectors, getStep, PortfolioWizardStepNames } from 'modules/ui/ChatBot'
import { ChatBot } from '../../components'
import { portfolioEvents } from 'modules/portfolios/state'

const mapStateToProps = (state, { push }: any) => ({
  actions: [],
  step: getStep(PortfolioWizardStepNames.applications),
  displayStep: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
  isStepOptional: !chatbotSelectors.isAnApplicationAccepted(state),
  title: 'Applications',
  displayTitleAction: true,
  titleActionText: 'Add applicant',
  titleActionDisabled:
    chatbotSelectors.isAnApplicationAccepted(state) || chatbotSelectors.isThereAnExistingTenant(state),
  description:
    'Add applicants if you are still in the vetting process. Skip this step if you have a signed lease agreement.',
  displayDescription: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
})

const mapDisptchToProps = (dispatch: any) => ({
  actionClickHandler: (action: any) => dispatch(action()),
  titleActionClickHandler: () => dispatch(portfolioEvents.togglePartyModal()),
})

export default connect(mapStateToProps, mapDisptchToProps)(ChatBot)
